/* Common Imports */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */
import ClassCard from "../../cards/ClassCard";
import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  flex: {
    margin: "4rem 0rem 4rem 0rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "1.875rem",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%",
  },
  heading: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    color: "#000000",
    fontWeight: "600",
    fontSize: "3rem",
    lineHeight: "3.1875rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
}));

const AboutClasses = () => {
  const [about, setAbout] = useState([]);

  useEffect(() => {
    fetch(AppConfig.apiUrlPrefix + "classes")
      .then((r) => r.json())
      .then((d) => {
        setAbout(d.about_classes);
      })
      .catch((e) => console.error(e));
  }, []);

  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.flex}>
        {about.map((object, key) => {
          return (
            <ClassCard
              key={key}
              icon={object.icon}
              heading={object.heading}
              subHeading={object.description}
            />
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default AboutClasses;
